export const apiEndpoints = {
    REGISTER: 'user/register',
    LOGIN: 'user/login',
    SOCIAL_LOGIN: 'user/social/login',
    CHECK_USER: 'user/check',
    SEND_OTP: 'user/send/otp',
    VERIFY_OTP: 'user/verify/otp',
    RESET_PASSWORD: 'user/password/reset',
    LOGOUT: 'user/web/logout',

    GET_PROFILE: 'user/profile/get',
    UPDATE_PROFILE: 'user/profile/update',
    CHANGE_PASSWORD: 'user/password/change',
    DELETE_PROFILE_IMAGE:'user/profile/image/delete',

    GET_ALL_CATEGORIES: 'category/get/all',

    GET_HOME_DATA: 'user/home/data/get',

    GET_PRODUCTS: 'user/product/get/all',
    GET_PRODUCT_DETAILS: 'product/details/get',
    SEARCH_PRODUCTS: 'user/product/search',
    GET_PRODUCT_FILTER_PARAMS: 'product/filter/parameters/get',
    FILTER_PRODUCTS: 'user/product/filter',

    ADD_TO_WISHLIST: 'user/whishlist/add',
    REMOVE_FROM_WISHLIST: 'user/whishlist/remove',
    GET_WISHLIST: 'user/whishlist/get',

    ADD_TO_CART: 'user/cart/add',
    REMOVE_FROM_CART: 'user/cart/remove',
    GET_CART: 'user/cart/get',

    ADD_ADDRESS: 'user/address/add',
    UPDATE_ADDRESS: 'user/address/update',
    DELETE_ADDRESS: 'user/address/delete',
    GET_ADDRESS: 'user/address/get/all',
    GET_COUNTRIES: 'country/get/all',
    GET_STATE_CITY_DETAILS: 'user/address/get/details',

    PLACE_ORDER: 'user/order/place',
    GET_ORDERS: 'user/order/get/all',
    GET_ORDER_DETAILS: 'order/details/get',
    ADD_REVIEW_RATING: 'user/order/review/add',
    CREATE_ORDER: 'user/order/create',
    BUY_NOW:'user/order/buynow',
    GET_GENERAL_SETTING:'user/generalsetting/get',

    RAISE_SUPPORT_TICKET: 'user/support/ticket/raise',
    UPDATE_SUPPORT_TICKET: 'support/ticket/update/status',
    GET_SUPPORT_TICKETS: 'user/support/ticket/get/all',
    ADD_MESSAGE_TO_TICKET: 'support/ticket/add/message',
    GET_SUPPORT_CHAT_HISTORY: 'support/ticket/get/chats',

    GET_NOTIFICATIONS: 'user/notification/get/all',

    GET_ADMIN_BANK_DETAILS: 'admin/bank/details/get',

    CONTACT_US: 'user/contactus',

    GET_ALL_COUPONS:'user/coupon/get/all',
    CHECK_VALIDITY_OF_COUPON:'user/coupon/validity/check'

}